function preloader() {
    setTimeout(function() {
        $('html, body').css('overflow-y', 'visible');
        $('.async-preloader').css('opacity', '0');
        setTimeout(function() {
            $('.async-preloader').hide();
        }, 300);
    }, 800);
}

$(document).ready(function() {
    preloader();
    
    checkIfMail();

    if (wSize >= 1280) {
        setTimeout(() => {
            if (!$('#async-contact-section-2 .aos-init').hasClass('aos-animate'))
                $('#async-contact-section-2 .aos-init').addClass('aos-animate')
        }, 800);
    }

    let slider8 = $("#async-contact-section-5 .owl-carousel").owlCarousel({
        items: 2,
        dots: false,
        nav: false,
        loop: false,
        smartSpeed: 500,
        stagePadding: 150,
        margin: 50,
        responsive: {
            0 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            360 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            375 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            390 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            414 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            428 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            480 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            768 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            800 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            1024 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            1280 : {
                items: 2,
                stagePadding: 100,
                margin: 40,
            },
            1366 : {
                items: 2,
                stagePadding: 100,
                margin: 40,
            },
            1440 : {
                items: 2,
                stagePadding: 130,
                margin: 50,
            },
            1536 : {
                items: 2,
                stagePadding: 130,
                margin: 50,
            },
            1600 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
            1920 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
            2560 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
        }
    });
});

function checkIfMail() {
    $('.list-value').each(function(index, element) {
        let text = $(element).text().trim();

        let emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;

        if (emailPattern.test(text)) {
            $(element).attr('href', `mailto:${text}`);
        }
    });

    $('.list-value').each(function(index, element) {
        let href = $(element).attr('href').trim();

        if (href == '') {
            $(element).attr('href', 'javascript:void(0)');
        }
    });
}

$('#async-contact-section-5 .owl-carousel img').on('mouseover', function() {
    if (wSize >= 1280) {
        $('#async-contact-section-5 .owl-carousel img').css('border-radius', '0');
        $(this).css('border-radius', '50%');
    }
}).on('mouseleave', function() {
    if (wSize >= 1280) {
        $(this).css('border-radius', '0');
    }
});